/**
 * @author Maxime Louf
 * Fonction permettant d'annuler / rétablir le scroll de la page
 * @version 1.0.0
 *
 * @param lock Boolean - Verrouille ou déverrouille le scroll de la page
 * @param targets CSS Selector List - Défaut : 'body'
 * @export {scrollLock} - Exemple : scrollLock(true, 'html, body')
 */

export function scrollLock(lock, targets = 'body') {
    const elementsToLock = document.querySelectorAll(targets);
    elementsToLock.forEach((el) => {
        if (lock === true) {
            el.classList.add('u-overflow-hidden');
        } else {
            el.classList.remove('u-overflow-hidden');
        }
    });
}
